import React from 'react';
import { useCompanyScope } from '../context/CompanyScopeContext';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';
import { Building2 } from 'lucide-react';

export default function CompanyScopeSelector() {
  const { companies, selectedCompanyId, setSelectedCompanyId, isCrossCompany } =
    useCompanyScope();

  if (!isCrossCompany) return null;

  const handleChange = (val) => {
    setSelectedCompanyId(val === '__all__' ? '' : val);
  };

  return (
    <div className="flex items-center gap-2" data-testid="company-scope-selector">
      <Building2 className="w-4 h-4 text-slate-500" />
      <Select
        value={selectedCompanyId || '__all__'}
        onValueChange={handleChange}
      >
        <SelectTrigger className="w-[260px] h-9" data-testid="company-scope-trigger">
          <SelectValue placeholder="Toutes les entreprises" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="__all__" data-testid="company-scope-all">
            Toutes les entreprises
          </SelectItem>
          {companies.map((c) => (
            <SelectItem
              key={c.id}
              value={c.id}
              data-testid={`company-scope-${c.id}`}
            >
              {c.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
